const SVG = ({ fill = 'currentColor', width = '36', height = '40', viewBox = '0 0 36 40' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M29.6144 27.3409L23.868 25.8894L23.3789 23.9136C24.9165 22.3758 25.9695 20.2636 26.2814 18.0969C27.1334 17.8545 27.7934 17.1166 27.9074 16.1909L28.2824 13.1606C28.3619 12.5212 28.1669 11.8742 27.7469 11.3893C27.5009 11.1045 27.1904 10.8893 26.8469 10.7575L26.9849 7.90447L27.5459 7.33629C28.3904 6.42869 29.0909 4.87266 27.6269 2.61506C26.5019 0.880327 24.591 0 21.945 0C20.901 0 18.498 0 16.26 1.51818C9.86996 1.65305 8.99998 4.65149 8.99998 7.57578C8.99998 8.25611 9.16346 9.78793 9.27146 10.7121C8.88594 10.8349 8.53648 11.0621 8.26346 11.3758C7.83596 11.8652 7.63796 12.5152 7.71749 13.1621L8.09246 16.1925C8.21544 17.1803 8.95794 17.9576 9.89696 18.1425C10.2075 20.2258 11.2065 22.2697 12.6555 23.7819L12.1335 25.8925L6.38696 27.344C2.62497 28.2909 0 35.3242 0 39.2424C0 39.6606 0.336023 40 0.750022 40H35.25C35.664 40 36 39.6576 36 39.2394C35.9999 35.3242 33.375 28.2909 29.6144 27.3409Z" />
  </svg>
)

export default SVG
